const RELOAD_KEY = "pegasus-reloaded-for-build";
const POLL_MS = 60 * 1000;

export function shouldReload(localId, remoteId, alreadyReloadedFor) {
  if (!localId || !remoteId || localId === remoteId) return false;
  if (alreadyReloadedFor === remoteId) return false;
  return true;
}

async function remoteBuildId() {
  const url = `${process.env.PUBLIC_URL || ""}/version.json?t=${Date.now()}`;
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) return null;
  const body = await res.json();
  return body && body.buildId;
}

export function watchForDeploy() {
  if (process.env.NODE_ENV !== "production") return;
  const localId = process.env.REACT_APP_BUILD_ID;
  if (!localId) return;

  const check = async () => {
    try {
      const remoteId = await remoteBuildId();
      const already = sessionStorage.getItem(RELOAD_KEY);
      if (!shouldReload(localId, remoteId, already)) return;
      sessionStorage.setItem(RELOAD_KEY, remoteId);
      window.location.reload();
    } catch {
      // offline or version.json not deployed yet
    }
  };

  check();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") check();
  });
  setInterval(check, POLL_MS);
}
